import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { ButtonVariant } from '@common';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-button',
  imports: [NgClass, SpinnerComponent],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  readonly disabled = input<boolean>();
  readonly fill = input<boolean>(false);
  readonly loading = input<boolean>(false);
  readonly type = input<HTMLButtonElement['type']>('button');
  readonly variant = input<ButtonVariant>('primary');
}
